import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Hero from '../components/sections/Hero';
import SectionDivider from '../components/common/SectionDivider';
import InViewLazy from '../components/common/InViewLazy';

const Services = React.lazy(() => import('../components/sections/Services'));
const Sectors = React.lazy(() => import('../components/sections/Sectors'));
const Projects = React.lazy(() => import('../components/sections/Projects'));
const Certifications = React.lazy(() => import('../components/sections/Certifications'));
const WhyChoose = React.lazy(() => import('../components/sections/WhyChoose'));
const Clients = React.lazy(() => import('../components/sections/Clients'));
const FAQSection = React.lazy(() => import('../components/sections/FAQSection'));
const FinalCTA = React.lazy(() => import('../components/sections/FinalCTA'));
const Capabilities = React.lazy(() => import('../components/sections/Capabilities'));

const HomePage = () => {
  const theme = useTheme();

  return (
    <Box component="main">
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, ${theme.palette.grey[100]})` }}>
        <Hero />
      </Box>
      
      <SectionDivider variant="line" color="divider" mt={6} mb={6} />
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(25,118,210,0.05))` }}>
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <Services />}</InViewLazy>
        </React.Suspense>
      </Box>
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(156,39,176,0.05))` }}>
        <SectionDivider variant="wave" color="secondary.main" mt={4} mb={2} />
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <Sectors />}</InViewLazy>
        </React.Suspense>
        <SectionDivider variant="line" color="secondary.main" mt={6} mb={6} />
      </Box>
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(2,136,209,0.05))` }}>
        <SectionDivider variant="wave" color="info.main" mt={4} mb={2} />
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <Projects />}</InViewLazy>
        </React.Suspense>
        <SectionDivider variant="line" color="info.main" mt={6} mb={6} />
      </Box>
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(76,175,80,0.05))` }}>
        <SectionDivider variant="wave" color="success.main" mt={4} mb={2} />
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <Certifications />}</InViewLazy>
        </React.Suspense>
        <SectionDivider variant="line" color="success.main" mt={6} mb={6} />
      </Box>
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(255,160,0,0.06))` }}>
        <SectionDivider variant="wave" color="warning.main" mt={4} mb={2} />
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <WhyChoose />}</InViewLazy>
        </React.Suspense>
        <SectionDivider variant="line" color="warning.main" mt={6} mb={6} />
      </Box>
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(69,90,100,0.06))` }}>
        <SectionDivider variant="wave" color="grey.700" mt={4} mb={2} />
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <Clients />}</InViewLazy>
        </React.Suspense>
        <SectionDivider variant="line" color="grey.700" mt={6} mb={6} />
      </Box>
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(25,118,210,0.05))` }}>
        <SectionDivider variant="wave" color="primary.main" mt={4} mb={2} />
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <Capabilities />}</InViewLazy>
        </React.Suspense>
        <SectionDivider variant="line" color="primary.main" mt={6} mb={6} />
      </Box>

      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(0,0,0,0.04))` }}>
        <SectionDivider variant="wave" color="divider" mt={4} mb={2} />
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <FAQSection />}</InViewLazy>
        </React.Suspense>
        <SectionDivider variant="line" color="divider" mt={6} mb={6} />
      </Box>

      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(25,118,210,0.07))` }}>
        <SectionDivider variant="wave" color="primary.main" mt={4} mb={2} />
        <React.Suspense fallback={<Box sx={{ height: 300 }} />}>
          <InViewLazy>{() => <FinalCTA />}</InViewLazy>
        </React.Suspense>
        <SectionDivider variant="line" color="primary.main" mt={6} mb={6} />
      </Box>
    </Box>
  );
};

export default HomePage;
